import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  sideMenuSubList: {
    listStyle: 'none',
    padding: 0,
    color: theme.palette.text.primary,
    margin: '0 8px 8px 8px',
    textAlign: 'right',
    overflow: 'hidden',
    maxHeight: 0,
    opacity: 0,
    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
    '&.open': {
      maxHeight: '500px',
      opacity: 1,
      paddingTop: 4,
      background: 'rgba(84, 57, 54, 0.5)',
      borderRadius: '0 0 4px 4px'
    },
    '& > .side-menu__list-item': {
      margin: 0,
      padding: '8px 8px 8px 16px',
      borderRadius: 0,
      '&:first-child': {
        paddingTop: 8
      },
      '&:last-child': {
        paddingBottom: 8,
        borderRadius: '0 0 4px 4px'
      }
    },
    '& > .side-menu__list-item--selected': {
      background: 'rgba(212, 199, 188, 0.2)',
      borderLeft: `3px solid ${theme.palette.secondary.main}`,
      '& a': {
        color: theme.palette.text.primary,
        fontWeight: 600
      }
    }
  },
  sideMenuSubItem: {
    paddingLeft: '48px !important',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px 10px 24px',
    margin: '4px 8px',
    borderRadius: theme.app.borderRadius.sm,
    color: theme.palette.primary.contrastText,
    background: 'transparent',
    transition: 'background .2s, transform .2s',
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1)',
      color: theme.palette.text.primary,
      transform: 'translateX(4px)'
    }
  },
  sideMenuWrapper: {
    width: 56,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      outline: 'none',
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden auto'
    }
  },

  closeButton: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      position: 'absolute',
      top: 7,
      right: 8,
      background: 'transparent',
      border: 'none',
      color: '#FFFFFF',
      cursor: 'pointer',
      padding: 8,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      transition: 'background .2s',
      zIndex: 10,
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.1)'
      },
      '& svg': {
        fontSize: '1.5rem'
      }
    }
  },

  sideMenuContainer: {
    height: '100vh',
    display: 'block',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    width: 56,
    transition: 'width .1s ease-out',
    overflowY: 'auto',
    boxSizing: 'border-box',

    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1,
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      transition: 'none',
      paddingBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      '& nav': {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        minHeight: 0,
        paddingBottom: 24
      }
    },

    '& .side-menu__title': {
      color: theme.palette.text.primary,
      fontSize: theme.app.typography.title.fontSize,
      fontWeight: theme.app.typography.title.fontWeight,
      fontFamily: theme.app.typography.fontFamily.main,
      padding: '16px 0 8px 0',
      textAlign: 'center',
      display: 'table-column',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 700,
        padding: '20px 0 16px 0',
        position: 'relative',
        zIndex: 5,
        pointerEvents: 'none'
      }
    },
    '& .side-menu__sub-title': {
      fontSize: theme.app.typography.subTitle.fontSize,
      fontWeight: theme.app.typography.subTitle.fontWeight,
      fontFamily: theme.app.typography.fontFamily.secondary,
      color: theme.palette.text.secondary,
      textAlign: 'center',
      display: 'table-column',
      fontStyle: 'normal',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },

    '& .side-menu__description': {
      display: 'none',
      fontSize: theme.app.typography.body.fontSize,
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    },
    '& .side-menu__userName': {
      marginTop: 5,
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'grid'
      }
    },
    '& .side-menu__profile': {
      fontSize: theme.app.typography.small.fontSize
    },
    '&': {
      zIndex: 2,
      width: 280,
      position: 'absolute',
      '& .side-menu__description,': {
        display: 'block'
      },
      '& .side-menu__title': {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      },
      '& .side-menu__sub-title': {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      },
      '& .side-menu__userName': {
        display: 'grid'
      },
      '& .side-menu__download-app': {
        display: 'unset'
      },
      '& .side-menu__sticky-value': {
        marginLeft: 0
      },
      '& > nav > ul > li button > span:last-child': {
        display: 'flex'
      },
      '& ul.open': {
        maxHeight: '500px',
        opacity: 1
      },
      '& > nav > ul > .side-menu__list-item--has-active-child': {
        background: 'rgba(84, 57, 54, 0.5)',
        borderLeft: 'none',
        '&.side-menu__list-item--expanded': {
          borderLeft: 'none'
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      zIndex: 2,
      width: 280,
      position: 'absolute',
      '& .side-menu__description': {
        display: 'block'
      },
      '& .side-menu__profile': {
        display: 'flex',
        fontWeight: 400,
        color: theme.app.colors.border.light
      },
      '& .side-menu__title': {
        display: 'block'
      },
      '& .side-menu__sub-title': {
        display: 'block'
      },
      '& .side-menu__userName': {
        display: 'block'
      },
      '& .side-menu__download-app': {
        display: 'unset'
      },
      '& .side-menu__sticky-value': {
        [theme.breakpoints.down('sm')]: {
          marginLeft: '0 !important'
        }
      },
      '& > nav > ul > li button > span:last-child': {
        display: 'flex'
      },
      '& ul.open': {
        maxHeight: '500px',
        opacity: 1
      },
      '& > nav > ul > .side-menu__list-item--has-active-child': {
        background: 'rgba(84, 57, 54, 0.5)',
        borderLeft: 'none',
        '&.side-menu__list-item--expanded': {
          borderLeft: 'none'
        }
      }
    }
  },

  sideMenuUser: {
    display: 'flex',
    width: 'calc(100% - 24px)',
    bottom: 32,
    left: 16
    // [theme.breakpoints.up('md')]: {
    //   position: 'absolute',
    // }
  },

  sideMenuUserLetra: {
    display: 'flex',
    marginRight: 8,
    fontWeight: 700,
    fontSize: theme.app.typography.body.fontSize,
    fontFamily: theme.app.typography.fontFamily.main,
    color: theme.palette.secondary.main,
    alignItems: 'center',
    width: 40,
    height: 40,
    background: '#543936',
    borderRadius: '50%',
    justifyContent: 'center'
  },

  sideMenuList: {
    marginTop: 72,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
      paddingBottom: 24,
      position: 'relative',
      zIndex: 1
    },
    '& > .side-menu__list-item': {
      margin: 8,
      padding: 8,
      borderRadius: theme.app.borderRadius.sm,
      transition: 'all .2s ease-in',
      color: theme.palette.primary.contrastText,
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        zIndex: 10
      },
      '&:hover': {
        background: '#543936',
        color: theme.palette.text.primary
      }
    },
    '& > .side-menu__list-item--expanded': {
      background: 'rgba(84, 57, 54, 0.5)',
      marginBottom: 0,
      borderRadius: '4px 4px 0 0',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 8,
        right: 8,
        height: 1,
        background: 'rgba(212, 199, 188, 0.2)'
      }
    },
    '& .side-menu__li_user': {
      margin: 10,
      padding: 10,
      borderRadius: theme.app.borderRadius.sm,
      transition: 'all .2s ease-in',
      color: theme.palette.primary.contrastText,
      width: 'calc(100% -24px)',
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 400
    },
    '& > .side-menu__list-item--selected': {
      background: '#543936',
      color: theme.palette.text.primary,
      borderLeft: `3px solid ${theme.palette.secondary.main}`
    },
    '& > .side-menu__list-item--has-active-child': {
      background: '#543936',
      color: theme.palette.text.primary,
      borderLeft: `3px solid ${theme.palette.secondary.main}`,
      [theme.breakpoints.up('md')]: {
        background: 'rgba(84, 57, 54, 0.5)',
        borderLeft: 'none',
        '&.side-menu__list-item--expanded': {
          borderLeft: 'none'
        }
      }
    },

    '& .side-menu__description-container': {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    },

    '& .side-menu__sticky-value': {
      width: 28,
      height: 28,
      // marginLeft: -25,
      backgroundColor: '#543936',
      alignItems: 'center',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      borderRadius: 50,
      fontWeight: 700,
      border: '1px solid rgba(255, 255, 255, 0.3)',

      [theme.breakpoints.down('sm')]: {
        marginLeft: -25
      }
    }
  },

  sideMenuUserSelected: {
    background: theme.palette.secondary.main,
    color: theme.palette.text.primary,

    '& .side-menu__userName, .side-menu__profile': {
      color: theme.palette.primary.main
    }
  },

  sideMenuItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
    color: 'inherit',
    position: 'relative',
    zIndex: 10,
    pointerEvents: 'auto',
    touchAction: 'manipulation',
    '& .side-menu__description': {
      marginLeft: 8
    },
    '& svg': {
      fill: 'white',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fontSize: '1.5rem',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: '0',
      userSelect: 'none'
    }
  },

  sideMenuItemDropdown: {
    justifyContent: 'space-between'
  },

  sideMenuItemContent: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },

  sideMenuToggle: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: 24,
    '& svg': {
      fill: 'white',
      fontSize: '1.5rem'
    },
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex'
    }
  },

  logoutOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
    animation: '$fadeIn 0.2s ease-in-out'
  },

  logoutContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20
  },

  logoutText: {
    color: '#fff',
    fontSize: 18,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    letterSpacing: '0.5px'
  },

  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },

  SideMenuDownloadApp: {
    alignItems: 'center',
    width: 'calc(100% - 21px)',
    height: 44,
    marginLeft: 8,
    marginBottom: 10,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    '& svg': {
      marginLeft: 8
    },
    '& a': {
      color: theme.palette.primary.contrastText,
      textDecoration: 'none',
      marginLeft: 8,
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'unset'
      }
    },
    '&:hover': {
      background: '#543936',
      color: theme.palette.text.primary,
      transition: 'all .2s ease-in',
      borderRadius: theme.app.borderRadius.sm,
      '& a': {
        color: theme.palette.text.primary
      },
      '& svg': {
        color: theme.palette.text.primary
      }
    },
    [theme.breakpoints.up('md')]: {
      '&:hover': {
        color: theme.palette.background.secondary.contrastText
      }
    }
  }
}))
